import React, { useEffect, useState } from "react";
import API, { BASE_URL } from "../api/Api";

const CsrGallery = () => {
  const [galleryData, setGalleryData] = useState([]);

  // 🔹 Fetch gallery data
  useEffect(() => {
    API.get("/gallery")
      .then((res) => {
        const data = res.data.data || [];

        // 🔹 Map API data → UI structure
        const mappedData = data.map((item) => ({
          title: item.title,
          views: item.impact_count,
          img: `${BASE_URL}/assets/images/${item.image}`,
        }));

        setGalleryData(mappedData);
      })
      .catch((err) => {
        console.error("Gallery API Error:", err);
      });
  }, []);

  return (
    <section className="ucsr-gal-section">
      <div className="container text-center mb-5">
        <span className="ucsr-gal-badge">
          <i className="fa-regular fa-eye"></i> SUCCESS STORIES
        </span>
        <h2 className="ucsr-gal-title">CSR Gallery</h2>
      </div>

      <div className="container">
        <div className="row g-4">
          {galleryData.map((item, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div className="ucsr-gal-card">
                <img src={item.img} alt={item.title} />

                <div className="ucsr-gal-overlay"></div>

                <div className="ucsr-gal-content">
                  <div className="ucsr-gal-card-title">
                    {item.title}
                  </div>

                  <div className="ucsr-gal-meta">
                    <i className="fa-regular fa-eye"></i>{" "}
                    {item.views}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CsrGallery;
